import { render, staticRenderFns } from "./LegalContent.vue?vue&type=template&id=650948a8"
import script from "./LegalContent.vue?vue&type=script&lang=js"
export * from "./LegalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports